import React from "react";

const UnityFpsPanel = ({ fps }) => {
  const getStatusColor = () => {
    if (!fps || fps === 0) return "#9ca3af";
    if (fps >= 30) return "#22c55e";          
    if (fps >= 20) return "#eab308";           
    return "#ef4444";  
  };                     

  return (
    <div style={styles.overlayContainer}>
      <div style={{ ...styles.statItem, color: getStatusColor() }}>
        <span style={styles.label}>FPS:</span>
        <span style={styles.value}>{fps ? Math.round(fps) : "..."}</span>
        {fps > 0 && fps < 30 && <span style={styles.warningText}>⚠️ BELOW TARGET</span>}
      </div>
    </div>
    // <div>
    //     {console.log(`FPS: ${fps ? Math.round(fps) : "..."}`)}
    //     {fps > 0 && fps < 30 ? (<span>{console.log("⚠️ BELOW TARGET")}</span>) : ''}
    // </div>
  );
};

const styles = {
  overlayContainer: {
    position: "absolute",
    top: "15px",
    left: "50%",
    transform: "translateX(-50%)",
    backgroundColor: "rgba(15, 23, 42, 0.85)", // Dark semi-transparent
    padding: "8px 16px",
    borderRadius: "12px",
    display: "flex",
    gap: "20px",
    zIndex: 1000,
    border: "1px solid rgba(255,255,255,0.1)",
    backdropFilter: "blur(4px)",
    boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1)",
  },
  statItem: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontWeight: "bold",
    fontFamily: "monospace",
  },
  label: {
    fontSize: "12px",
    color: "#94a3b8",
    textTransform: "uppercase",
  },
  value: {
    fontSize: "18px",
  },
  warningText: {
    fontSize: "10px",
    marginLeft: "5px",
    padding: "2px 4px",
    backgroundColor: "rgba(239, 68, 68, 0.2)",
    borderRadius: "4px",
  }
};

export default UnityFpsPanel;